import { APISettings } from '../../config/ApiSettings';
import { BlobContainer } from '../enums/BlobContainer';
import { BaseAPI } from './baseApi';
import {AxiosProgressEvent} from "axios";

// import { FileStorage as fileInterface } from '../interfaces/FileStorage';
// const baseUrl = APISettings.apiUrl;
const baseUrl = new APISettings().getApiURL();

const uploadFile = (file: FormData, onUploadProgress: (event: AxiosProgressEvent) => void, containerName: BlobContainer, uid: string) => {
  return (
      BaseAPI.axios.post(
          `${baseUrl}/FileStorage/UploadViaStream/${containerName}/${uid}`,
          file,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress,
          }
      ));
}

const deleteFile = (fileName: string, containerName: string) => {
  return  BaseAPI.axios.delete(`${baseUrl}/FileStorage/Delete/${containerName}/${fileName}`);
}

export default { uploadFile, deleteFile };
